import { Illustration } from "@/ds";
import { EQUIPE_EMPTY_MESSAGE } from "../equipe-obra.constants";
import styles from "./equipe-vazia.module.scss";
import type { EquipeVaziaProps } from "./types-equipe-vazia";

/** Estado vazio da equipe (Figma `tabela` 12227:422499): frase e a ilustração `ilustração`. */
export function EquipeVaziaView({ mensagem = EQUIPE_EMPTY_MESSAGE }: EquipeVaziaProps) {
  return (
    <div className={styles.vazia}>
      <p className={styles.texto} data-testid="equipe-obra-empty">
        {mensagem}
      </p>
      <Illustration
        name="sem-equipe"
        size="natural"
        decorative
        testId="equipe-obra-ilustracao-vazio"
      />
    </div>
  );
}

/** Aba Calendário sem a obra criada (Figma 12251:426256): frase e a ilustração `ilu-no-charts`. */
export function CalendarioVazio({ mensagem }: { mensagem: string }) {
  return (
    <div className={styles.calendario} data-testid="equipe-obra-calendario">
      <p className={styles.textoCalendario}>{mensagem}</p>
      <Illustration
        name="sem-dados"
        decorative
        testId="equipe-obra-calendario-ilustracao"
        className={styles.ilustracaoCalendario}
      />
    </div>
  );
}
